export default "__VITE_ASSET__d3d6659d__"